import React, { useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { AdminThemeContext } from './AdminThemeContext';
import { FormSurfaceContext } from './FormSurfaceContext';

export const AdminThemeScope: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const adminTheme = useContext(AdminThemeContext);
  if (!adminTheme) return <>{children}</>;
  return (
    <FormSurfaceContext.Provider value={false}>
      <ThemeProvider theme={adminTheme}>{children}</ThemeProvider>
    </FormSurfaceContext.Provider>
  );
};
